import script from "./RouteSubscription.vue?vue&type=script&setup=true&lang=ts"
export * from "./RouteSubscription.vue?vue&type=script&setup=true&lang=ts"

import "./RouteSubscription.vue?vue&type=style&index=0&id=6da0c80e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da0c80e"]])

export default __exports__